export const FILTERED_EMOJIS = [
  'eggplant',
  'peach',
  'banana',
  'tongue',
  'bikini',
  'sweat_drops',
  'cherries',
  'underage',
  'hocho',
  'dagger_knife',
  'axe',
  'gun',
  'bomb',
  'bow_and_arrow',
  'skull_and_crossbones',
  'pirate_flag',
  'crossed_swords',
  'firecracker',
  'dagger_knife',
  'herb',
  'syringe',
  'smoking',
  'beer',
  'beers',
  'wine_glass',
  'cocktail',
  'tropical_drink',
  'champagne',
  'clinking_glasses',
  'middle_finger',
  'hankey',
  'see_no_evil',
  'hear_no_evil',
  'speak_no_evil',
  'right_anger_bubble',
  'anger',
  'place_of_worship',
  'no_entry',
  'no_entry_sign',
  'no_pedestrians',
  'x',
]
